import { SANDBOX_MODE_DONT_ASK, SANDBOX_MODE_FULL_ACCESS, SANDBOX_MODE_READ_ONLY, SANDBOX_MODE_WORKSPACE_WRITE, THREAD_DEFAULTS_SANDBOX_MODE_PREF_KEY } from '@/lib/appConstants.js';
import getModelOptionById from '@/lib/model/getModelOptionById.js';
import { DEFAULT_PIEVE_MODEL_ID } from '@shared/pieve/defaultModel.js';
import { getDefaultPieveReasoningEffortForModel } from '@shared/pieve/modelReasoning.js';

const getDefaultReasoningEffortForModel = (modelId) => {
  return getDefaultPieveReasoningEffortForModel(modelId);
};

const resolveSelectableComposerModelId = (modelId) => {
  const modelOption = getModelOptionById({
    modelId,
    includeHidden: true
  });

  if (modelOption?.value) {
    return modelOption.value;
  }

  return DEFAULT_PIEVE_MODEL_ID;
};

const normalizeThreadSandboxMode = (value, fallback = SANDBOX_MODE_WORKSPACE_WRITE) => {
  const normalized = String(value || '')
    .trim()
    .toLowerCase();
  const compact = normalized.replace(/[\s_\-']/g, '');
  const resolvedFallback = fallback ?? SANDBOX_MODE_WORKSPACE_WRITE;

  if (!normalized) {
    return resolvedFallback;
  }

  if (compact === 'workspacewrite' || compact === 'default') {
    return SANDBOX_MODE_WORKSPACE_WRITE;
  }

  if (compact === 'fullaccess' || compact === 'dangerfullaccess' || compact === 'bypasspermissions') {
    return SANDBOX_MODE_FULL_ACCESS;
  }

  if (compact === 'readonly' || compact === 'ask' || compact === 'question') {
    return SANDBOX_MODE_READ_ONLY;
  }

  if (compact === 'dontask' || compact === 'rulesonly' || compact === 'noask') {
    return SANDBOX_MODE_DONT_ASK;
  }

  return resolvedFallback;
};

const getPreferredThreadSandboxModeFromPrefs = (prefMap = {}) => {
  return normalizeThreadSandboxMode(prefMap?.[THREAD_DEFAULTS_SANDBOX_MODE_PREF_KEY], SANDBOX_MODE_WORKSPACE_WRITE);
};

export { getDefaultReasoningEffortForModel, getPreferredThreadSandboxModeFromPrefs, normalizeThreadSandboxMode, resolveSelectableComposerModelId };
